import React from "react";
import { CircularProgress } from "@material-ui/core";
import { Container } from "./styles";

const LoadingModal = () => {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
};

export default LoadingModal;
